//# sourceMappingURL=when.mjs.map
/// <reference types="./when.d.mts" />
import * as $remote from "../../data_types/data/remote.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $ref from "../../redraw/redraw/ref.mjs";
import * as $html from "../../redraw_dom/redraw/dom/html.mjs";
import { Ok } from "../gleam.mjs";

export function some(opt, next) {
  if (opt instanceof Some) {
    let opt$1 = opt[0];
    return next(opt$1);
  } else {
    return $html.none();
  }
}

export function some_(opt, render, next) {
  if (opt instanceof Some) {
    let opt$1 = opt[0];
    return next(opt$1);
  } else {
    return render();
  }
}

export function ok(res, next) {
  if (res instanceof Ok) {
    let res$1 = res[0];
    return next(res$1);
  } else {
    return $html.none();
  }
}

export function ok_(res, render, next) {
  if (res instanceof Ok) {
    let res$1 = res[0];
    return next(res$1);
  } else {
    return render();
  }
}

/**
 * Render the following element iif the value is `True`.
 */
export function true$(res, next) {
  if (res) {
    return next();
  } else {
    return $html.none();
  }
}

/**
 * Render the following element iif the value is `False`.
 */
export function false$(res, next) {
  if (res) {
    return $html.none();
  } else {
    return next();
  }
}

/**
 * Render the following element iif the value is 'Loaded(data)'
 */
export function remote_data_loaded(data, next) {
  if (data instanceof $remote.Loaded) {
    let data$1 = data[0];
    return next(data$1);
  } else {
    return $html.none();
  }
}

export function ref(ref, next) {
  let $ = $ref.current(ref);
  if ($ instanceof Some) {
    let data = $[0];
    return next(data);
  } else {
    return undefined;
  }
}
